// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".populartopicslist[data-v-35dd5c54]{display:grid;grid-template-columns:repeat(auto-fill,minmax(250px,1fr));grid-template-rows:repeat(1,1fr);grid-column-gap:40px;grid-row-gap:20px;margin-bottom:2rem}", ""]);
// Exports
module.exports = exports;
